import { Component, OnInit } from '@angular/core';
import { ScriptsModule } from '../../../modules/scripts.module';
import { IntermService } from '../../../services/general/interm.service';
declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html',
  styleUrls: ['./perfil.component.css'],
  providers: [IntermService]
})
export class PerfilComponent implements OnInit {

    
  public model;
  public modelCambio;
  //NOTIFICACION   
  public tituloInterm;
  public mensajeInterm;
  public rutaInterm;

  constructor(private int:IntermService) { }   
    
  ngOnInit() {
    let scripts = new ScriptsModule;
    scripts.loadScript('assets/js/scripts/intermediarios.js');
    scripts.loadScript('assets/js/slider_fss.js');
      
    this.model={};
    this.modelCambio={};
    
    var usuario= JSON.parse(localStorage.getItem('currentUsuario'));   
    $('#divCargador').show();
    this.int.getPerfil( usuario.id).then(resc => {
        this.model= resc;           
    $('#divCargador').hide();
    });
      
  }
    actualizarData(){
        
        var u= JSON.parse(localStorage.getItem('currentUsuario'));         
        this.model.id=u.id;
        $('#divCargador').show();
        this.int.savePerfil(JSON.stringify(this.model) ).then(resc => {
                     $('#divCargador').hide();
                                             
                        this.mensajeInterm="Proceso exitoso";
                        this.rutaInterm="";
                        $('#modalNotif').modal('show');
                        //this.router.navigate(['/intermediarios','cotizacion',resc.codigo]);          
            
            
                        var usuario= JSON.parse(localStorage.getItem('currentUsuario'));   
                        usuario.email=resc.email;
                        usuario.empresa=resc.nombre;
                        localStorage.setItem('currentUsuario',  JSON.stringify(usuario) );
            
                   }); 
    }
    
    cambiarContrasenia(){
        
        if(this.modelCambio.password1==this.modelCambio.password2 && this.modelCambio.password1.trim()!=""){
                var u= JSON.parse(localStorage.getItem('currentUsuario'));         
                this.modelCambio.id=u.id;
                $('#divCargador').show();
                this.int.setPass(JSON.stringify(this.modelCambio) ).then(resc => {
                             $('#divCargador').hide();

                                if(resc.success==0){
                                
                                    this.mensajeInterm="Problema al procesar el cambio de contraseña";
                                    this.rutaInterm="";
                                    $('#modalNotif').modal('show');
                                    //this.router.navigate(['/intermediarios','cotizacion',resc.codigo]);          

                                }
                                if(resc.success==1){
                                
                                    this.mensajeInterm="Proceso exitoso";
                                    this.rutaInterm="";
                                    $('#modalNotif').modal('show');
                                    //this.router.navigate(['/intermediarios','cotizacion',resc.codigo]);          

                                }
                                if(resc.success==2){
                                    this.mensajeInterm="La clave antigua no coincide";
                                    this.rutaInterm="";
                                    $('#modalNotif').modal('show');
                                    //this.router.navigate(['/intermediarios','cotizacion',resc.codigo]);      
                                }                               

                           }); 
            }
        else{            
             this.mensajeInterm="La nueva clave no coincide";
                        this.rutaInterm="";
                        $('#modalNotif').modal('show');
                        //this.router.navigate(['/intermediarios','cotizacion',resc.codigo]);     
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/intermediarios/perfil/perfil.component.ts